import {Injectable} from '@angular/core';
import {TokenService} from './token.service';
import {RequestMethod, RestService} from './rest.service';
import {ResponseSnackbarService} from './response-snackbar.service';
import {ApiEndpoints} from '../constants/ApiEndpoints';
import {GeneralConstant} from '../constants/GeneralConstant';
import {environment} from '../../../environments/environment';

/**
 * The user's choice between the classic layout and the new design. The choice is stored on the
 * user and travels in the token, so after saving it the token is refreshed and the page reloaded.
 */
@Injectable({
  providedIn: 'root'
})
export class DesignPreferenceService {

  constructor(private tokenService: TokenService,
              private restService: RestService,
              private snackBar: ResponseSnackbarService) {
  }

  isNewDesign(): boolean {
    return this.tokenService.getUserFromToken()?.newDesign === true;
  }

  /** Where a signed-in user lands: the dashboard in the new design, otherwise their role's page. */
  landingUrl(defaultUrl: string): string {
    return this.isNewDesign() ? '/dashboard' : defaultUrl;
  }

  setNewDesign(enabled: boolean): void {
    const url = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.PROFILE.UPDATE_NEW_DESIGN}`;
    this.restService.restRequest<any>(RequestMethod.POST, url, {body: {enabled}}).subscribe(
      response => {
        if (!response?.success) {
          this.snackBar.onResponse(response);
          return;
        }
        this.refreshTokenAndReload();
      },
      error => this.snackBar.onResponse(error)
    );
  }

  protected reload(): void {
    window.location.reload();
  }

  private refreshTokenAndReload(): void {
    this.tokenService.refreshToken().subscribe(
      result => {
        if (result?.success) {
          this.tokenService.saveToken(result.data.token);
          this.tokenService.saveRefreshToken(result.data.refreshToken);
          this.reload();
        } else {
          this.showAppliesNextLogin();
        }
      },
      () => this.showAppliesNextLogin()
    );
  }

  private showAppliesNextLogin(): void {
    this.snackBar.onResponseMessage('Saved — it will apply the next time you log in.',
      GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS);
  }
}
